/**
 * place-gltf - spawns GLTF mesh actors into the world. Iterates over GLTF descriptors,
 * creates ModelMeshActor instances, applies transforms, and adds them to the world.
 */
import { ModelMeshActor, type ModelMeshActorOptions } from '../actors/ModelMeshActor.js';

import type { ActorMiscInfo, Transform } from './common.js';
import type { World } from '../game/World.js';


export interface GltfArgs {
  path: string;
  transform?: Transform;
  miscInfo?: ActorMiscInfo; // Optional metadata for the actor
}

export async function placeGltfs(args: {
  world: World;
  gltfs: GltfArgs[];
}): Promise<ModelMeshActor[]> {

  const promises: Promise<void>[] = [];
  const actors: ModelMeshActor[] = [];

  for (const gltfArg of args.gltfs) {
    const options: ModelMeshActorOptions = {
      modelUrl: gltfArg.path,
    };

    const transform = gltfArg.transform;
    if (transform) {
      transform.position && (options.position = transform.position);
      transform.rotation && (options.rotation = transform.rotation);
      transform.scale && (options.scale = transform.scale);
    }

    const actor = ModelMeshActor.create(options);
    promises.push(actor.waitForComponentsToLoad());

    if (gltfArg.miscInfo) {
      const { name, ...rest } = gltfArg.miscInfo;
      if (name) actor.setName(name);
      Object.assign(actor.editorData, rest);
    }

    args.world.addActors(actor);
    actors.push(actor);
  }

  await Promise.all(promises);

  return actors;
}
